'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactI18next = require('react-i18next');

var _chemist = require('chemist');

var _lodash = require('lodash');

var _FormInput = require('../FormInput');

var _money = require('../../helpers/money');

var Money = _interopRequireWildcard(_money);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeliveryRatesField = (_dec = (0, _reactI18next.translate)(), _dec2 = (0, _chemist.configurable)(), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(DeliveryRatesField, _React$Component);

  function DeliveryRatesField() {
    (0, _classCallCheck3.default)(this, DeliveryRatesField);
    return (0, _possibleConstructorReturn3.default)(this, (DeliveryRatesField.__proto__ || (0, _getPrototypeOf2.default)(DeliveryRatesField)).apply(this, arguments));
  }

  (0, _createClass3.default)(DeliveryRatesField, [{
    key: 'rateIdAttribute',
    value: function rateIdAttribute(rateIndex) {
      return 'order_shipment_' + this.props.index + '_rate_' + rateIndex;
    }
  }, {
    key: 'rateDescription',
    value: function rateDescription(rate) {
      if (!rate.description) {
        return '';
      }

      return _react2.default.createElement(
        'p',
        { className: 't-small' },
        rate.description
      );
    }
  }, {
    key: 'displayRateCost',
    value: function displayRateCost(rate) {
      var t = this.props.t;


      if (rate > 0) {
        return Money.format(rate, this.props.currency, this.props.config.store);
      }

      return t('spree.free');
    }
  }, {
    key: 'isSelected',
    value: function isSelected(rateId) {
      return this.props.selectedRate && this.props.selectedRate.id === rateId;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('input', {
          name: 'order[shipments_attributes][' + this.props.index + '][id]',
          type: 'hidden',
          value: this.props.shipmentId
        }),
        this.props.deliveryRates.map(function (rate, rateIndex) {
          return _react2.default.createElement(
            _FormInput.Field,
            { key: (0, _lodash.uniqueId)(), inputType: 'radio' },
            _react2.default.createElement(_FormInput.Radio, {
              name: 'order[shipments_attributes][' + _this2.props.index + '][selected_shipping_rate_id]',
              id: _this2.rateIdAttribute(rateIndex),
              value: '' + rate.id,
              defaultChecked: _this2.isSelected(rate.id),
              required: true,
              disabled: true
            }),
            _react2.default.createElement(
              _FormInput.Label,
              {
                className: 'a-label a-label--large',
                htmlFor: _this2.rateIdAttribute(rateIndex)
              },
              rate.name,
              ',\xA0',
              _react2.default.createElement(
                'span',
                { className: 't-text--secondary' },
                _this2.displayRateCost(rate.cost)
              )
            ),
            _this2.rateDescription(rate)
          );
        })
      );
    }
  }]);
  return DeliveryRatesField;
}(_react2.default.Component), _class2.propTypes = {
  shipmentId: _react.PropTypes.any.isRequired,
  deliveryRates: _react.PropTypes.array.isRequired,
  selectedRate: _react.PropTypes.object.isRequired,
  index: _react.PropTypes.number.isRequired,
  currency: _react.PropTypes.string.isRequired
}, _temp)) || _class) || _class);
exports.default = DeliveryRatesField;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/DeliveryForm/deliveryRatesField.js
// module id = 2457
// module chunks = 0